import { render, staticRenderFns } from "./Lxwm.vue?vue&type=template&id=16d28621&scoped=true&"
import script from "./Lxwm.vue?vue&type=script&lang=js&"
export * from "./Lxwm.vue?vue&type=script&lang=js&"
import style0 from "./Lxwm.vue?vue&type=style&index=0&id=16d28621&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d28621",
  null
  
)

export default component.exports